import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Capability, CurrentUser } from './types';

interface AuthState {
  user: CurrentUser | null;
  capabilities: Capability[];
  /** False until /auth/me has resolved once, so guards do not flash. */
  initialised: boolean;
}

const initialState: AuthState = {
  user: null,
  capabilities: [],
  initialised: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    sessionEstablished: (
      state,
      action: PayloadAction<{ user: CurrentUser; capabilities: Capability[] }>,
    ) => {
      state.user = action.payload.user;
      state.capabilities = action.payload.capabilities;
      state.initialised = true;
    },
    sessionExpired: (state) => {
      state.user = null;
      state.capabilities = [];
      state.initialised = true;
    },
    authChecked: (state) => {
      state.initialised = true;
    },
  },
});

export const { sessionEstablished, sessionExpired, authChecked } = authSlice.actions;
export const authReducer = authSlice.reducer;
